'use strict';

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('../../../_lib/buildLocalizeFn/index.js');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../../../_lib/buildLocalizeArrayFn/index.js');

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var weekdayValues = {
  narrow: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sa'],
  "short": ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  "long": ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
};
var monthValues = {
  "short": ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  "long": ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
};
var timeOfDayValues = {
  uppercase: ['AM', 'PM'],
  lowercase: ['am', 'pm'],
  "long": ['a.m.', 'p.m.']
};

function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'º';
}

var localize = {
  ordinalNumber: ordinalNumber,
  weekday: (0, _index2["default"])(weekdayValues, 'long'),
  weekdays: (0, _index4["default"])(weekdayValues, 'long'),
  month: (0, _index2["default"])(monthValues, 'long'),
  months: (0, _index4["default"])(monthValues, 'long'),
  timeOfDay: (0, _index2["default"])(timeOfDayValues, 'long', function (hours) {
    return hours / 12 >= 1 ? 1 : 0;
  }),
  timesOfDay: (0, _index4["default"])(timeOfDayValues, 'long')
};
exports["default"] = localize;
module.exports = exports['default'];